import React from 'react';
import styled from '@emotion/styled';
import { Container, Grid } from '@mui/material';

const Wrapper = styled.div`
  padding: 50px 0px;
`;

const StepBox = styled.div`
  padding: 8px 24px;
  border-radius: 10px;
  border: 1px solid #222222;
  color: rgba(255,255,255,0.4);
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;

  &.active {
    border-color: #fff;
    color: #fff;
  }
   @media (max-width: 600px) {
    font-size: 11px;
      padding: 8px 10px;
  }
`;

const Arrow = styled.span`
color: rgba(255,255,255,0.3);
margin: 0 14px;
transition: all 0.3s ease;
font-size: 25px;

&.active {
color: #fff;
}
`;

const steps = [
  { id: 1, label: "Plan Selection" },
  { id: 2, label: "Create Your Account" },
  { id: 3, label: "Payment" }
];

export default function Navigations({ currentStep = 2 }) {
  return (
    <Wrapper>
      <Container maxWidth="xl">
        <Grid container spacing={2} alignItems="center" justifyContent="center">
          <Grid item>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {steps.map((step, index) => (
                <React.Fragment key={step.id}>
                <StepBox className={currentStep === step.id ? 'active' : ''}>
            {step.label}
            </StepBox>
            {index < steps.length - 1 && <Arrow className={currentStep > step.id ? 'active' : ''}>›</Arrow>}
            </React.Fragment>
              ))}
            </div>
          </Grid>
        </Grid>
      </Container>
    </Wrapper>
  );
}
